import { Component, OnInit, Input } from '@angular/core';
import { AbstractAddComponent } from '../../../../shared/abstracts/add/abstract-add/abstract-add.component';
import { IObservation, IPatient } from '@ahryman40k/ts-fhir-types/lib/R4';
import { FormGroup, FormControl, FormArray } from '@angular/forms';
import { getCode, getComp } from '../../life-mode/add/life-mode-add.component';

export const INPUTS: any[] = [
  {
    label: 'WEIGHT',
    unit: 'kg',
    required: true
  },
  {
    label: 'HEIGHT',
    unit: 'cm',
    required: true
  },
  {
    label: 'BMI',
    unit: 'kg/m*m',
    required: true,
    readonly: true
  },
  {
    label: 'PULSE',
    unit: 'bpm'
  },
  {
    label: 'SYSTOLIC',
    unit: 'Hgmm'
  },
  {
    label: 'DIASTOLIC',
    unit: 'Hgmm'
  }
];

const WEIGHT_CODE = '29463-7';
const HEIGHT_CODE = '8302-2';
const BMI_CODE = '39156-5';

@Component({
  selector: 'inc-bio-params-add',
  templateUrl: './bio-params-add.component.html',
  styleUrls: ['./bio-params-add.component.scss'],
})
export class BioParamsAddComponent extends AbstractAddComponent<IObservation> implements OnInit {
  inputs = INPUTS;

  @Input() patient: IPatient;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.form.controls.subject.setValue({ display: this.patient.name[0].text, reference: this.patient.id });
    if (this.inData) {
      this.form.patchValue(this.inData);
    }
  }

  save(inData: IObservation) {
    this.inData ? this.callUpdate.emit(inData) : this.callSave.emit(inData);
    this.form.reset(this.form.value);
  }

  bmiCalc(): void {
    const weightValue = (((this.form.controls.component as FormArray).controls
      .find((el: FormGroup) => el.value.code.coding[0].code === WEIGHT_CODE) as FormGroup)
      .controls.valueQuantity as FormGroup).controls.value.value;

    const heightValue = (((this.form.controls.component as FormArray).controls
      .find((el: FormGroup) => el.value.code.coding[0].code === HEIGHT_CODE) as FormGroup)
      .controls.valueQuantity as FormGroup).controls.value.value;

    (((this.form.controls.component as FormArray).controls
      .find((el: FormGroup) => el.value.code.coding[0].code === BMI_CODE) as FormGroup)
      .controls.valueQuantity as FormGroup).controls.value
      .setValue(weightValue && heightValue ? (weightValue / Math.pow((heightValue / 100), 2)).toFixed(2) : null);
  }

  resetForm() {
    return new FormGroup({
      id: new FormControl(),
      status: new FormControl('final'),
      subject: new FormGroup({
        reference: new FormControl(''),
        display: new FormControl('')
      }),
      issued: new FormControl(new Date().toISOString()),
      code: getCode('28636-9', 'Initial evaluation note', 'BIOPARAMETERS'),
      component: new FormArray([
        getComp(WEIGHT_CODE, 'Body Weight', 'WEIGHT', 'kg'),
        getComp(HEIGHT_CODE, 'Body height', 'HEIGHT', 'cm'),
        getComp(BMI_CODE, 'Body mass index (BMI) [Ratio]', 'BMI', 'kg/m2'),
        getComp('8867-4', 'Heart rate', 'PULSE', 'bpm'),
        getComp('8480-6', 'Systolic blood pressure', 'SYSTOLIC', 'Hgmm'),
        getComp('8462-4', 'Diastolic blood pressure', 'DIASTOLIC', 'Hgmm'),
      ])
    });
  }
}
